<script setup>
import ToolbarBottom from "./ToolbarBottom.vue";
import {defineProps} from "vue";
import {useAlarmsStore} from "@/stores/alarmsStore";
import {useSDSStore} from "@/stores/sdsStore";
import {useMediaStore} from "@/stores/mediaStore";

//const emit = defineEmits(['update:selected']);
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  selected: String
});

function updateSelection(val) {
  //emit('update:selected', val);
  useMediaStore().selectedTab = val
}
</script>

<template>
  <v-navigation-drawer
      color="surface-light"
      name="drawer"
      permanent
      width="170"
  >
    <v-container class="d-flex flex-column h-100 pa-0 ">
      <v-list nav>
<!--        <v-list-item :active="selected === 'RADIO'" prepend-icon="mdi-radio-tower" title="RADIO" value="RADIO"-->
<!--                     @click="updateSelection('RADIO')"></v-list-item>-->
<!--        <v-list-item :active="selected === 'SDS'" :class="{'lost-sds': useSDSStore().lostSDS}"-->
<!--                     prepend-icon="mdi-message-text" title="SDS" value="SDS"-->
<!--                     @click="updateSelection('SDS')" ></v-list-item>-->
<!--        <v-list-item :active="selected === 'ALARMS'" :class="{'lost-alarm': useAlarmsStore().lostAlarm}"-->
<!--                     prepend-icon="mdi-alarm-light" title="Alarms"-->
<!--                     value='ALARMS'-->
<!--                     @click="updateSelection('ALARMS')"></v-list-item>-->
<!--        -->

        <v-list-item :active="useMediaStore().selectedTab === 'RADIO'" prepend-icon="mdi-radio-tower" title="RADIO" value="RADIO"
                     @click="updateSelection('RADIO')"></v-list-item>
        <v-list-item :active="useMediaStore().selectedTab === 'SDS'" :class="{'lost-sds': useSDSStore().lostSDS}"
                     prepend-icon="mdi-message-text" title="SDS" value="SDS"
                     @click="updateSelection('SDS')" ></v-list-item>
        <v-list-item :active="useMediaStore().selectedTab === 'ALARMS'" :class="{'lost-alarm': useAlarmsStore().lostAlarm}"
                     prepend-icon="mdi-alarm-light" title="Alarms"
                     value='ALARMS'
                     @click="updateSelection('ALARMS')"></v-list-item>

      </v-list>
      <!-- Spazio flessibile -->
      <v-spacer></v-spacer>
      <!-- Widget in fondo -->
      <div class="d-flex flex-column align-center overflow-auto">
        <ToolbarBottom class="position-absolute bottom-0"/>
      </div>
    </v-container>
  </v-navigation-drawer>
</template>

<style scoped>
.lost-alarm {
  background-color: #EE5A5AFF !important;
  color: white !important;
}

.lost-sds {
  background-color: #f49405 !important;
  color: white !important;
}
</style>
